import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-18" data-mp="3iqztf3fsgbxb">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Una habilidad técnica puede abrir nuevas posibilidades." data-id="element-19" data-mp="3npb39e632mfj" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="3dr3qz8mqosjv">
          {benefits.map(b => <li key={b.title} className="flex gap-2.5 rounded-xl border border-navy/10 bg-gris p-2.5 sm:p-3" data-id="element-21" data-mp="3dor20bikdhxb">
              <span aria-hidden="true" className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-wifi text-white" data-id="element-22" data-mp="34qfewjgwp29m">
                <b.icon size={15} data-id="element-23" data-mp="xy4tdm9ku8e6" />
              </span>
              <div data-id="element-24" data-mp="12xr67ulhtmmg">
                <h3 className="text-[0.82rem] font-extrabold text-navy sm:text-sm" data-id="element-25" data-mp="12yaojcf22d10">{b.title}</h3>
                <p className="mt-0.5 text-[0.78rem] leading-snug text-negro/75 sm:text-sm" data-id="element-26" data-mp="2bdcpfe1df5vc">{b.desc}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}